import { render, staticRenderFns } from "./orderSettings.vue?vue&type=template&id=29a0d8a8&scoped=true"
import script from "./orderSettings.vue?vue&type=script&lang=js"
export * from "./orderSettings.vue?vue&type=script&lang=js"
import style0 from "./orderSettings.vue?vue&type=style&index=0&id=29a0d8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a0d8a8",
  null
  
)

export default component.exports